import { NOT_RATED } from "../../utils/scoreCalculator";

export default function RatingPill({ rating, tone = "neutral", size = "md" }) {
  const label = rating || NOT_RATED;
  return <span className={`rating-pill tone-${label === NOT_RATED ? "neutral" : tone} size-${size}`}>{label}</span>;
}
